import { createClient, Entry } from "contentful";

import {
  BlogPostFieldTypes,
  RecipeFieldTypes,
} from "src/types/contentfulTypes";

const contentfulClient = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID as string,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN as string,
});

const getAllContentfulEntries = async (contentType: string) => {
  const limit = 100;
  let skip = 0;
  let total = 0;
  let items: Entry[] = [];

  do {
    const response = await contentfulClient.getEntries({
      content_type: contentType,
      limit,
      skip,
    });

    total = response.total;
    skip += response.items.length;
    items = [...items, ...response.items];
  } while (skip < total);

  return items;
};

export const getContentfulRecipes = async () => {
  const recipes = await getAllContentfulEntries("article");

  return recipes.map((recipe) => {
    const {
      cooking_time,
      image,
      ingredients,
      name,
      steps,
      tags,
      teaser,
      slug,
      serves,
    }: RecipeFieldTypes = recipe.fields as unknown as RecipeFieldTypes;

    let heroImage = {};
    let thumbnailImage = {};
    let strippedTags;

    if (tags) {
      strippedTags = tags.map((tag: any) => ({
        id: tag.sys.id,
        title: tag.fields.title,
        slug: tag.fields.slug,
        type: tag.fields.type,
      }));
    }

    if (image) {
      const { public_id, version, format } = (image as any[])[0];

      heroImage = {
        url: `https://res.cloudinary.com/dfvhyk2ut/image/upload/f_auto,q_auto,w_700/v${version}/${public_id}.${format}`,
        alt: name,
      };
      thumbnailImage = {
        url: `https://res.cloudinary.com/dfvhyk2ut/image/upload/f_auto,q_auto,w_360/v${version}/${public_id}.${format}`,
        alt: name,
      };
    }

    return {
      id: recipe.sys.id,
      cooking_time,
      ingredients,
      name: name.trim(),
      steps,
      tags: strippedTags,
      teaser,
      heroImage,
      thumbnailImage,
      slug: slug.trim(),
      serves: serves ? serves : 2,
    };
  });
};

export const getContentfulTags = async () => {
  const tags = await getAllContentfulEntries("tag");

  const formattedTags = tags.map((tag: Entry) => ({
    id: tag.sys.id,
    title: tag.fields.title,
    slug: tag.fields.slug,
    type: tag.fields.type,
  }));

  return formattedTags.sort((a, b) => {
    if (!a.title || !b.title) return 0;
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
  });
};
